import { AuthOptions } from 'auth0-js';

// NOTE: this path needs to be included in the "Allowed Callback URLs" configuration in Auth0
export const CALLBACK_PATH = '/auth-confirmed';

// NOTE: this path needs to be included in the "Allowed Logout URLs" configuration in Auth0
export const LOGOUT_REDIRECT_PATH = '/';

export const scope =
    'openid profile email app_metadata read:users read:current_user offline_access';

export const authorizationParams = {
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    scope,

    /**
     * This value needs to match what @auth0/auth0-react expects so that the `onRedirectCallback`
     * function is called for both passwordless and ULP login flows
     *
     * See https://github.com/auth0/auth0-react/issues/82#issuecomment-711479502
     */
    redirect_uri: `${window.location.origin}${CALLBACK_PATH}`,
};

export const Auth0Options: AuthOptions = {
    domain: import.meta.env.VITE_AUTH0_DOMAIN,
    clientID: import.meta.env.VITE_AUTH0_CLIENT_ID,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    scope,
    redirectUri: `${window.location.origin}${CALLBACK_PATH}`,
    responseType: 'token id_token',
};

interface EmailPasswordlessStartRequest {
    email: string;
    connection: 'email';
    send: 'link' | 'code';
    phoneNumber?: never; // Email requests do not have a phone number
}
interface SmsPasswordlessStartRequest {
    phoneNumber: string;
    connection: 'sms';
    send: 'link' | 'code';
    email?: never; // SMS requests do not have an email
}
export type PasswordlessStartRequest = EmailPasswordlessStartRequest | SmsPasswordlessStartRequest;

interface EmailPasswordlessLoginRequest {
    connection: 'email';
    email: string;
    verificationCode: string;
    phoneNumber?: never; // Email requests do not have a phone number
}
interface SmsPasswordlessLoginRequest {
    connection: 'sms';
    phoneNumber: string;
    verificationCode: string;
    email?: never; // SMS requests do not have an email
}
export type PasswordlessVerifyRequest = EmailPasswordlessLoginRequest | SmsPasswordlessLoginRequest;
